import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { mydtasService } from "../services/mydtasService";

export const fetchMydtasNotifications = createAsyncThunk(
  "mydtasNotification/fetchAll",
  () => mydtasService.getNotifications(),
);

export const markMydtasNotificationAsRead = createAsyncThunk(
  "mydtasNotification/markAsRead",
  (notificationId) =>
    mydtasService.markNotificationAsRead(notificationId).then(() => notificationId),
);

const initialState = {
  fetching: false,
  notifications: [],
  filteredNotifications: [],
  totalCount: 0,
};

export const mydtasNotificationSlice = createSlice({
  name: "mydtasNotification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // fetchAll
      .addCase(fetchMydtasNotifications.pending, (state) => {
        state.fetching = true;
      })
      .addCase(fetchMydtasNotifications.fulfilled, (state, action) => {
        state.fetching = false;
        const data = action.payload?.data ?? action.payload ?? [];
        state.notifications = data;
        state.filteredNotifications = data;
        state.totalCount = data.length;
      })
      .addCase(fetchMydtasNotifications.rejected, (state) => {
        state.fetching = false;
      })
      // markAsRead
      .addCase(markMydtasNotificationAsRead.fulfilled, (state, action) => {
        const id = action.payload;
        const markRead = (item) => {
          if (item.mydtaS_BILDIRIM_ID === id) {
            item.okundu = "EVET";
            item.okunmA_TARIHI = new Date().toISOString();
          }
        };
        state.notifications.forEach(markRead);
        state.filteredNotifications.forEach(markRead);
      });
  },
});

export const mydtasNotificationReducer = mydtasNotificationSlice.reducer;
